import { render, staticRenderFns } from "./spa_annulla.vue?vue&type=template&id=c746a106&"
import script from "./spa_annulla.vue?vue&type=script&lang=js&"
export * from "./spa_annulla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports